
import { CSSProperties, MouseEventHandler} from 'react'
import tw, { classnames, TArg, position, inset, zIndex, translate, cursor, opacity, pointerEvents } from "tailwindcss-classnames";
import {NextIcon, PreviousIcon} from '../Icons'

type ArrowProps = {
    onClick?: MouseEventHandler<HTMLButtonElement>
    twClassName?: TArg | string
    className?: string
    style?: CSSProperties
}

const SLICK_DISABLED = "slick-disabled"

// Only react-slick's state class is kept; its slick-arrow/slick-prev/slick-next classes carry the vendor
// theme's own 20px positioning, which these arrows replace.
const isDisabled = (className?: string) => className?.split(/\s+/).includes(SLICK_DISABLED) ?? false

const arrowStyle = `scale-75 "sm:scale-100" ${classnames(position("absolute"), inset("bottom-0", "xl:top-1/2", "xl:bottom-auto"), zIndex("z-10"), translate("translate-y-full"))}`

const enabledStyle = classnames(cursor("cursor-pointer"))

const disabledStyle = `${SLICK_DISABLED} ${classnames(opacity("opacity-25"), cursor("cursor-default"), pointerEvents("pointer-events-none"))}`

const stateStyle = (disabled: boolean) => disabled ? disabledStyle : enabledStyle

export const CarouselNext = ({onClick, twClassName, className, style}: ArrowProps) => {
    const disabled = isDisabled(className)
    return (
        <button
            type="button"
            aria-label="הבא"
            aria-disabled={disabled}
            className={`${arrowStyle} "xl:-left-8" ${twClassName} ${stateStyle(disabled)} ${classnames(inset("left-5", "sm:left-6", "md:left-0", "right-auto"))}`}
            style={style}
            onClick={disabled ? undefined : onClick}
        >
            <PreviousIcon />
        </button>
    )
}

export const CarouselPrev = ({
    onClick,
    twClassName,
    className,
    style
}: ArrowProps) => {
    const disabled = isDisabled(className)
    return (
        <button
            type="button"
            aria-label="הקודם"
            aria-disabled={disabled}
            className={`${arrowStyle} xl:-right-8 ${twClassName} ${stateStyle(disabled)} ${classnames(inset("right-5", "sm:right-6", "md:right-0", "left-auto"))}`}
            style={style}
            onClick={disabled ? undefined : onClick}
        >
            <NextIcon  />
        </button>
    )
}
